<template>
  <div class="fourthOut" :class="{ allComplete: isOrderEnd }">
    <div class="fourthOutContent">
      <h3>{{ isOrderEnd ? "合同信息" : "签署合同" }}</h3>
      <div v-if="progress > 3">
        <div
          class="contract"
          v-for="(item, index) of dataList"
          :key="index"
          :style="{
            background:
              item.status == -5 ||
              item.status == -4 ||
              item.status == -3 ||
              item.status == -2 ||
              item.status == -1
                ? 'linear-gradient(270deg, #FBB29C 0%, #F67A63 100%)'
                : '#F0F1FF',
          }"
          @click="itemClick(item)"
        >
          <div
            class="contractTop"
            v-if="!isOrderEnd || (isOrderEnd && item.status != 2)"
          >
            <!-- 驳回 -->
            <div
              class="contractTopReject"
              v-if="
                item.status == -5 ||
                item.status == -4 ||
                item.status == -3 ||
                item.status == -2 ||
                item.status == -1
              "
            >
              <div>
                <img src="./../../../../assets/decoration/order/t.png" alt="" />
                <span v-if="item.status == -1">被驳回</span>
                <span v-if="item.status == -2 || item.status == -5"
                  >被撤回</span
                >
                <span v-if="item.status == -3">已超时</span>
                <span v-if="item.status == -4">已作废</span>
                <div v-if="item.status == -1" @click.stop="seeReason(item)">
                  驳回原因
                  <img
                    v-if="item.isSeeAll"
                    src="./../../../../assets/decoration/order/noSeeMore.png"
                  />
                  <img
                    v-else
                    src="./../../../../assets/decoration/order/seeMore.png"
                  />
                </div>
              </div>
              <div v-if="item.isSeeAll && item.status == -1">
                <p>{{ item.reason }}</p>
              </div>
            </div>
            <!-- 不是驳回 -->
            <div
              class="contractTopNormal"
              v-if="
                item.status == 0 ||
                item.status == 1 ||
                item.status == 3 ||
                item.status == 4 ||
                item.status == 2
              "
            >
              <span v-if="item.status == 0">生成中</span>
              <span v-if="item.status == 1">待签署</span>
              <span
                v-if="item.status == 3 || item.status == 4 || item.status == 2"
                >待审核</span
              >
              <button
                @click.stop="toSign(item.contract_id)"
                v-if="item.status == 1"
              >
                去签署
              </button>
            </div>
          </div>
          <div class="contractContent">
            <p>
              合同编码 <span>{{ item.contract_number }}</span>
            </p>
            <h4>{{ item.contract_name }}</h4>
            <span
              >合同有效期：{{ item.validity_start }}~{{
                item.validity_end
              }}</span
            >
          </div>
        </div>
      </div>
      <div v-else class="notdata">
        <img src="./../../../../assets/decoration/order/noData.png" alt="" />
        <p>订单被终止，此项无数据</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    progress: {
      default: 1,
    },
    isOrderEnd: {
      default: false,
    },
    id: {
      default: "",
    },
    order_sn: {
      default: "",
    },
    order_status: {
      default: 5,
    },
  },
  data() {
    return {
      dataList: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    //   获取合同列表
    getData() {
      this.$api
        .post("decoration/member/order/contract/list", {
          order_sn: this.order_sn,
        })
        .then((res) => {
          //   console.log(res);
          this.dataList = res.list;
          this.dataList.forEach((item, index) => {
            item.isSeeAll = false;
          });
          this.dataList = [...this.dataList];
        });
    },
    //   去签署
    toSign(contract_id) {
      this.$router.push({
        path: "/decoration/order/signContract",
        query: {
          contract_id: contract_id,
        },
      });
    },
    // 查看合同
    itemClick(item) {
      if (item.status == 1) {
        this.toSign(item.contract_id);
      } else if (item.status == 0) {
        this.$toast("合同生成中，请耐心等待");
      } else {
        if (!this.isOrderEnd) {
          this.order_status = 5;
        }
        this.$router.push({
          path: "/decoration/order/seeContract",
          query: {
            contract_id: item.contract_id,
            order_status: this.order_status,
          },
        });
      }
    },
    seeReason(item) {
      item.isSeeAll = !item.isSeeAll;
      this._watcher.run();
    },
  },
};
</script>
<style lang="less" scoped>
.fourthOut {
  margin: 12px 16px;
  padding-bottom: 48px;
  .fourthOutContent {
    background-color: #ffffff;
    border-radius: 12px;
    padding: 20px 12px 40px;
    h3 {
      display: inline-block;
      font-size: 20px;
      font-weight: 700;
      color: #333333;
      border-bottom: 5px solid #d2c3ff;
      margin: 0 0 12px 12px;
      height: 20px;
    }
    .contract {
      margin-top: 16px;
      border-radius: 12px;
      background: #f0f1ff;
      padding: 1px 0;
      .contractTop {
        padding: 10px 8px 7px 16px;
        .contractTopReject {
          display: flex;
          flex-direction: column;
          font-size: 14px;
          color: #ffffff;
          div:first-child {
            display: flex;
            align-items: center;
            img {
              width: 16px;
              height: 16px;
              margin-right: 5px;
            }
            span {
              flex: 1;
            }
            div {
              display: flex;
              align-items: center;
              img {
                margin: 0;
              }
            }
          }
          div:last-child {
            p {
              font-weight: 500;
              line-height: 20px;
              margin-top: 16px;
            }
          }
        }
        .contractTopNormal {
          display: flex;
          align-items: center;
          justify-content: space-between;
          span {
            font-size: 14px;
            color: #333333;
            font-weight: bold;
          }
          button {
            background: #f0f1ff;
            border-radius: 12px;
            border: 1px solid #5853e9;
            font-size: 13px;
            font-weight: 600;
            color: #5853e9;
            padding: 3px 13px;
          }
        }
      }
      .contractContent {
        background: #ffffff;
        border-radius: 10px;
        padding: 12px 13px;
        margin: 2px 3px;
        p {
          font-size: 13px;
          color: #333333;
          padding-bottom: 13px;
          border-bottom: 1px solid #f0f1ff;
          span {
            font-size: 11px;
            word-break: break-word;
            word-break: break-all;
          }
        }
        h4 {
          font-size: 15px;
          font-weight: bold;
          color: #333333;
          margin: 16px 0 14px;
        }
        > span {
          font-size: 13px;
          color: #999999;
        }
      }
    }
    .notdata {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding: 32px 0 30px;
      img {
        width: 101px;
        height: 85px;
      }
      p {
        font-size: 13px;
        color: #999999;
        margin-top: 7px;
      }
    }
  }
}
.allComplete {
  margin: 0;
  .fourthOutContent {
    padding: 31px 12px 40px;
    border-radius: 0 0 16px 16px;
    h3 {
      font-size: 16px;
      height: 16px;
      margin: 0 0 8px 12px;
    }
  }
}
</style>
